import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '../config/rem'
import './assets/style/main.less'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)
Vue.config.productionTip = false

import axios from 'axios'
Vue.config.productionTip = false
Vue.prototype.$axios=axios
import VueAMap from 'vue-amap';

Vue.use(VueAMap);

VueAMap.initAMapApiLoader({
  key: 'a96e945c351237fbb5c16c9b25279dc6',
  plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType'],
  v: '1.4.15',
  uiVersion: '1.0.11'
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
